import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { ThemeProvider } from 'styled-components';

import { useRouter } from '@/hooks/useRouter';
import { commonMessages } from '@/messages/common';
import { theme } from '@/theme';

import * as S from './SkiptoContentLink.styles';

const SkipToContentLink: React.FC = () => {
  const router = useRouter();

  useEffect(() => {
    const resetFocus = () => {
      document.body.setAttribute('tabindex', '-1');
      document.body.focus();
      document.body.removeAttribute('tabindex');
    };

    router.events.on('routeChangeComplete', resetFocus);

    return () => {
      router.events.off('routeChangeComplete', resetFocus);
    };
  }, [router.events]);

  return (
    <ThemeProvider theme={theme}>
      <S.SkipToContentLink className='skip-link' href='#main-content'>
        <FormattedMessage {...commonMessages.skipToContent} />
      </S.SkipToContentLink>
    </ThemeProvider>
  );
};

export default SkipToContentLink;
